var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.707498 6.941C0.741662 6.87296 0.792907 6.82193 0.861237 6.78791C0.929566 6.75389 0.997895 6.73688 1.08331 6.73688H5.57599V4.95086C5.57599 4.86581 5.59307 4.79777 5.62723 4.72974C5.6614 4.6617 5.71264 4.61067 5.78097 4.57665C5.8493 4.54263 5.91763 4.52562 6.00305 4.52562C6.08846 4.52562 6.15679 4.54263 6.22512 4.57665C6.25928 4.59366 6.29345 4.62768 6.32761 4.6617L10.3932 9.13526C10.4103 9.15227 10.4274 9.18629 10.4445 9.2033C10.4786 9.27134 10.5128 9.33938 10.5128 9.42443C10.5128 9.50947 10.4786 9.57751 10.4445 9.64555C10.4274 9.66256 10.4103 9.69658 10.3932 9.71359L6.32761 14.1871C6.29345 14.2212 6.25928 14.2552 6.22512 14.2722C6.15679 14.3062 6.08846 14.3402 6.00305 14.3402C5.91763 14.3402 5.8493 14.3062 5.78097 14.2722C5.71264 14.2382 5.6614 14.1871 5.62723 14.1191C5.59307 14.0511 5.57599 13.983 5.57599 13.898V12.112H1.08331C0.997895 12.112 0.929566 12.0779 0.861237 12.0439C0.792907 12.0099 0.741662 11.9589 0.707498 11.8908C0.673333 11.8228 0.65625 11.7548 0.65625 11.6697V7.16212C0.65625 7.07708 0.673333 7.00904 0.707498 6.941Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9112 0.324219H21.6878C21.9098 0.324219 22.1319 0.528335 22.1319 0.749462V21.5524C22.1319 21.7735 21.9098 21.9946 21.6878 21.9946H19.9112C19.6891 21.9946 19.4841 21.7735 19.4841 21.5524V0.749462C19.4841 0.528335 19.6891 0.324219 19.9112 0.324219Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8203 0.332031H26.5969C26.8189 0.332031 27.041 0.536148 27.041 0.757274V21.5602C27.041 21.7813 26.8189 22.0024 26.5969 22.0024H24.8203C24.5982 22.0024 24.3932 21.7813 24.3932 21.5602V0.757274C24.3932 0.536148 24.5982 0.332031 24.8203 0.332031Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9858 0.324219H16.7624C16.9844 0.324219 17.2065 0.528335 17.2065 0.749462V21.5524C17.2065 21.7735 16.9844 21.9946 16.7624 21.9946H14.9858C14.7637 21.9946 14.5587 21.7735 14.5587 21.5524V0.749462C14.5587 0.528335 14.7637 0.324219 14.9858 0.324219Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCause);
export default __webpack_public_path__ + "static/media/cause.99b507f93562e85e0971eebbbb2bbfdd.svg";
export { ForwardRef as ReactComponent };